export default "__VITE_ASSET__CEynHZHk__"